<template>
    <div>
        <page-header></page-header>
        <div class="setting">
            <el-card v-loading.body="userInfo.loading" class="box-card">
                <div class="clearfix card-heard">
                    <span style="line-height: 36px;">个人信息</span>
                    <el-button @click="editUser" style="float: right" type="primary">
                        {{userInfo.isEdit?"完成":"编辑"}}
                    </el-button>
                </div>
    
                <div v-if="userInfo.isEdit" class="user-info">
                    <el-form label-position="right" label-width="80px" :model="userInfo">
                        <el-form-item label="姓名">
                            <el-input v-model="userInfo.name"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱">
                            <el-input v-model="userInfo.email"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话">
                            <el-input v-model="userInfo.phone"></el-input>
                        </el-form-item>
                    </el-form>
    
                </div>
                <div v-else class="user-info">
                    <div class="display-input">
                        <span> 姓名</span>
                        <span> {{userInfo.name}}</span>
                    </div>
                    <div class="display-input">
                        <span> 邮箱</span>
                        <span> {{userInfo.email}}</span>
                    </div>
                    <div class="display-input">
                        <span> 联系电话</span>
                        <span> {{userInfo.phone}}</span>
                    </div>
    
                </div>
            </el-card>
            <el-card class="box-card" >
                <div class="clearfix card-heard">
                    <span style="line-height: 36px;">修改密码</span>
                    <el-button style="float: right" type="primary">
                        编辑
                    </el-button>
                </div>
                <div class="user-info">
                    <!-- <el-form label-position="right" label-width="100px" :model="form">
                                            <el-form-item label="旧密码">
                                                <el-input v-model="form.name"></el-input>
                                            </el-form-item>
                                            <el-form-item label="新密码">
                                                <el-input v-model="form.region"></el-input>
                                            </el-form-item>
                                            <el-form-item label="重复密码">
                                                <el-input v-model="form.type"></el-input>
                                            </el-form-item>
                                        </el-form> -->
                    <div class="display-input">
                        <span> 旧密码:</span>
                        <span> 13213132</span>
                    </div>
                    <div class="display-input">
                        <span> 密码:</span>
                        <span> 13213132</span>
                    </div>
                    <div class="display-input">
                        <span> 验证密码:</span>
                        <span> 13213132</span>
                    </div>
    
                </div>
            </el-card>
    
        </div>
    </div>
</template>

<script>
import pageHeader from '../../components/tempControl/header'

export default {

    name: 'setting',
    components: {
        pageHeader
    },
    data() {
        return {
            userInfo: {
                isEdit: false,
                name: "管理员",
                phone: "18888888888",
                email: "leemma@leemma.com",
                loading: false
            },

        }
    },
    methods: {
        editUser() {
            if (this.userInfo.isEdit) {
                this.userInfo.loading=true
                setTimeout(() => {
                    this.$message({
                        message: '用户信息修改成功',
                        type: 'success'
                    });
                    this.userInfo.loading=false
                }, 1000)


            } else {

            }
            this.userInfo.isEdit = !this.userInfo.isEdit
        }
    }

}
</script>

<style scoped>
.setting {
    display: flex;
}

.el-form-item__label {
    font-size: 0.18rem
}

.card-heard {
    font-size: 0.28rem;
    margin-bottom: 70px;
}

.box-card {
    width: 37.5%;
    max-width: 484px;
    margin-right: 20px;
}

.el-button a {
    color: #fff
}

.user-info .display-input {
    line-height: 36px;
    margin-bottom: 22px
}

.display-input>span:first-child {
    display: inline-block;
    width: 80px;
    text-align: right;
    margin-right: 20px;
}

@media (max-width:800px) {
    .setting {
        flex-direction: column;
    }
    .box-card {
        width: 100%;
        margin: 10px 0
    }
}
</style>



// WEBPACK FOOTER //
// setting.vue?f35f1d46